import { useProjectStagesState } from 'screens/Admin/ProjectTypes/hooks/useProjectStagesState'
import { IProjectStage, IProjectType } from 'screens/Admin/ProjectTypes/projectTypes.types'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  value: string | null
  options: IProjectStage[]
  name: string
  onChange: (val: string, name: string) => void
}

const FaqProjectStageSelect = (props: IProps) => {
  const { projectStagesMap } = useProjectStagesState()

  const handleSelect = (val: IProjectType | null) => {
    props.onChange(val?.id, props.name)
  }

  const selected = projectStagesMap[props.value]

  return (
    <Dropdown
      options={props.options}
      selectedOption={selected}
      title='Этап проекта'
      onSelect={handleSelect}
      getOptionKey={(o) => o?.id}
      getOptionLabel={(o) => o?.name}
    />
  )
}

export default FaqProjectStageSelect
